export default "__VITE_ASSET__DVK3Nmm5__"